export const TOWER_START_COMPLETED = "tower/startCompleted";
export const TOWER_GUESS_COMPLETED = "tower/guessCompleted";
export const TOWER_HINT_COMPLETED = "tower/hintCompleted";
export const TOWER_STATUS_COMPLETED = "tower/statusCompleted";
export const TOWER_CLEAR = "tower/clear";
export const TOWER_THEMES_COMPLETED = "project/tower/themesCompleted";
export const TOWER_THEME_SELECTION_CHANGED = "project/tower/themeSelectionChanged";

export const TOWER_ANSWER_COMPLETED = "project/tower/answerCompleted";
